module.exports = __webpack_public_path__ + "static/media/gulp.19b92315.svg";